import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function SocialFacebook({ idVariant = '', className }: Props) {
  return (
    <IconBase name="social-facebook" w={16} className={className}>
      <g clipPath={`url(#socialfacebook_${idVariant}_clip0_2565_10704)`}>
      <path d="M16 0H0V16H16V0Z" fill="currentColor"/>
      <path d="M13.732 7.34924L13.4862 9.67369H11.628V16.4186H8.83687V9.67413H7.44531V7.34969H8.83687V5.95013C8.83687 4.05947 9.62265 2.92969 11.8573 2.92969H13.7155V5.25413H12.5533C11.6858 5.25413 11.6284 5.58124 11.6284 6.18747V7.34969L13.732 7.34924Z" fill="white"/>
      </g>
      <defs>
      <clipPath id={`socialfacebook_${idVariant}_clip0_2565_10704`}>
      <rect width="16" height="16" fill="currentColor"/>
      </clipPath>
      </defs>
    </IconBase>
  )
}

export default SocialFacebook
